import { render } from "./PortfolioEtaerio.vue?vue&type=template&id=173829cc&scoped=true"
import script from "./PortfolioEtaerio.vue?vue&type=script&lang=js"
export * from "./PortfolioEtaerio.vue?vue&type=script&lang=js"

import "./PortfolioEtaerio.vue?vue&type=style&index=0&id=173829cc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173829cc"]])

export default __exports__